module.exports = __webpack_public_path__ + "img/westnetz-logo.f8dae31d.gif";